import { PropsWithChildren, ReactNode } from 'react';
import { twMerge } from 'tailwind-merge';

interface CardWithIconProps {
  dataTest?: string;
  icon?: ReactNode;
  heading?: ReactNode;
  centered?: boolean;
  className?: string;
}

function CardWithIcon({
  dataTest = 'card',
  icon,
  heading,
  centered = true,
  children,
  className,
}: PropsWithChildren<CardWithIconProps>) {
  return (
    <>
      {Boolean(heading) && (
        <h1
          className="font-semibold text-3xl text-center xl:text-left lg:hidden mb-12"
          data-test={`${dataTest}-heading`}
        >
          {heading}
        </h1>
      )}

      <div
        className={twMerge(
          'flex flex-col',
          centered && 'items-center',
          'gap-6 border rounded-lg bg-background mb-5 relative',
          icon ? 'pt-12 px-5 pb-5' : 'p-5',
          className,
        )}
        data-test={`${dataTest}-layout`}
      >
        {Boolean(icon) && (
          <div
            className="absolute left-1/2 -translate-x-1/2 w-20 h-20 -top-10 lg:left-16"
            data-test={`${dataTest}-icon`}
          >
            {icon}
          </div>
        )}

        {Boolean(heading) && (
          <h1
            className="hidden lg:block font-semibold text-3xl xl:text-left"
            data-test={`${dataTest}-heading-2`}
          >
            {heading}
          </h1>
        )}

        {children}
      </div>
    </>
  );
}

export default CardWithIcon;
